/* INTEGY V773: accessible numeric SKU retry on genuine empty search.
   Never changes catalog prices, product statuses, count labels, or query automatically.
   A digit-only search can miss a prefixed SKU (34067 vs C34067). */
(function(){
 'use strict';
 if (!/^\/search\/?$/i.test(location.pathname)) return;
 var q=(new URLSearchParams(location.search).get('q')||'').trim();
 if (!/^\d{4,8}$/.test(q)) return;
 var candidate='C'+q;
 function add(){
   if (document.getElementById('integy-v773-sku-retry')) return;
   var headings=document.querySelectorAll(
     'main#site-main #integy-v520-search-results[data-integy-v520-search-mode="empty"] .integy-v720-search-empty h1, '+
     'main#site-main .productgrid--no-results-title,main#site-main [class*="no-results-title"]');
   var heading=null;
   for(var i=0;i<headings.length;i++){
     var h=headings[i];
     if(h.getClientRects().length && getComputedStyle(h).visibility!=='hidden'){heading=h;break;}
   }
   if(!heading) return;
   var params=new URLSearchParams(location.search);
   params.set('q',candidate);params.set('type','product');params.set('options[unavailable_products]','show');params.delete('page');
   var url=location.pathname+'?'+params.toString();
   var p=document.createElement('p');p.id='integy-v773-sku-retry';
   p.setAttribute('role','note');
   p.style.cssText='margin:12px 0 18px;color:#243e30;font-size:14px;line-height:1.6;';
   p.appendChild(document.createTextNode('Some part numbers include a letter prefix. '));
   var a=document.createElement('a');a.href=url;
   a.textContent='Try searching SKU '+candidate;
   a.style.cssText='color:#11623e;text-decoration:underline;font-weight:700;text-underline-offset:3px;';
   p.appendChild(a);heading.insertAdjacentElement('afterend',p);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',add,{once:true});else add();
 window.setTimeout(add,1200);
 window.setTimeout(add,4500);
 window.setTimeout(add,9000);
 var observed=document.getElementById('integy-v520-search-results')||document.querySelector('main#site-main');
 if(observed&&window.MutationObserver){
   var queued=false;
   new MutationObserver(function(){if(queued)return;queued=true;window.setTimeout(function(){queued=false;add();},80);})
     .observe(observed,{childList:true,subtree:true});
 }
 document.addEventListener('shopify:section:load',add);
})();